<template>
  <van-tabbar    v-model="active" @change="onChange">
    <van-tabbar-item icon="home-o" to="index">出入库</van-tabbar-item>
    <van-tabbar-item icon="search" to="search">当前库存</van-tabbar-item>
    <van-tabbar-item icon="friends-o" to="logout">个人中心</van-tabbar-item>
  </van-tabbar>
</template>

<script>
  import {Tabbar,TabbarItem} from 'vant';
  export default {
    components: {
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
    },
    methods: {
        onChange(index) {
        this.active = index
      },

    },
    computed: {
      active: {
          get() {
            return this.$store.state.activeIndex
          },
          set(v) {
            this.$store.commit('changeActiveIndex', v)
          }
      }
    },
    

  }
</script>

<style scoped>

</style>